// Vue 2 portal for classic dialogs. Escape rail/toolbar stacking contexts while
// retaining the current theme and leaving the legacy mobile experience alone.
const portals = new WeakMap();
export default {
  inserted(el, binding, vnode) {
    if (!el.closest('.stockchart-default')) return;
    const anchor = document.createComment('classic dialog');
    el.parentNode.insertBefore(anchor, el);
    const host = document.createElement('div');
    host.className = 'stockchart-default legacy-overlay-host';
    // The dialog can carry its own reactive theme; never portal it into itself.
    let theme = el.parentElement.closest('.light-theme, .dark-theme');
    // On a component-root v-if reopen Vue may insert into the former portal
    // host before this hook runs. Resolve the live logical owner, not that
    // detached DOM ancestry, so every opening inherits the same reactive theme.
    let owner = vnode && vnode.context;
    while ((!theme || !document.documentElement.contains(theme)) && owner) {
      const root = owner.$el;
      if (root && root.nodeType === 1 && !el.contains(root) && document.documentElement.contains(root)) {
        theme = root.closest('.light-theme, .dark-theme');
      }
      owner = owner.$parent;
    }
    theme = theme || document.body;
    const fullscreen = document.fullscreenElement;
    const root = fullscreen && !fullscreen.contains(theme) ? fullscreen : theme;
    root.appendChild(host);
    host.appendChild(el);
    portals.set(el, { host, anchor });
  },
  unbind(el, binding, vnode, oldVnode, isDestroy) {
    const portal = portals.get(el);
    if (!portal) return;
    const { host, anchor } = portal;
    if (anchor.parentNode) {
      // Root-component v-if removal has already detached the vnode. Restoring
      // it here would resurrect stale inputs alongside the reopened dialog.
      if (!isDestroy) anchor.parentNode.insertBefore(el, anchor);
      anchor.parentNode.removeChild(anchor);
    }
    host.remove();
    portals.delete(el);
  }
};
